import classnames from 'classnames';
import { PropsWithChildren } from 'lib-shared-types-utils';

import styles from './keyboardKey.module.scss';

type KeyboardKeyVariant = 'simple' | 'rich';

type KeyboardKeyProps = PropsWithChildren & {
  /** The display variant of the key. */
  variant?: KeyboardKeyVariant;
};

/** Represents a component for displaying a keyboard key. */
export const KeyboardKey = (props: KeyboardKeyProps): JSX.Element => {
  return (
    <kbd className={classnames(styles.root, styles[props.variant ?? 'rich'])}>
      {props.children}
    </kbd>
  );
};
